/* Chill PDP chip nav.
   1. Lifts the spec accordions and PDF links out of the description into
      their own cards. Those nodes are injected client-side after load, so
      the split retries under a MutationObserver rather than assuming they
      are present at DOM ready.
   2. Extends the chip row with every content section that exists on the
      page, and owns scrolling for all chips via a capture-phase handler
      (the page swallows animated scrolls, so it jumps directly). */
(function () {
  var HEADER_OFFSET = 96;
  var root = null;
  var io = null;
  var tracked = [];

  function jumpTo(target) {
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, target);
    html.style.scrollBehavior = prev;
  }

  function scrollToEl(el) {
    if (!el) return;
    var target = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET);
    var start = window.pageYOffset;
    if (Math.abs(target - start) < 2) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      jumpTo(target);
      return;
    }

    try {
      window.scrollTo({ top: target, behavior: 'smooth' });
    } catch (e) {
      jumpTo(target);
      return;
    }

    /* Smooth scrolling is frame-driven, so it never starts in a background
       tab or where the animation is unsupported. If nothing has moved
       shortly after, land on the target directly. */
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) < 2) jumpTo(target);
    }, 250);
  }

  function observe(chip, target) {
    tracked.push({ chip: chip, target: target });
    if (io) io.observe(target);
  }

  function addChip(id, label, beforeSel) {
    if (!root || root.querySelector('a[href="#' + id + '"]')) return;
    var el = document.getElementById(id);
    if (!el) return;
    var a = document.createElement('a');
    a.className = 'cv-pdp-chip';
    a.href = '#' + id;
    a.textContent = label;
    a.setAttribute('data-cv-chip-extra', '');
    var before = beforeSel ? root.querySelector(beforeSel) : null;
    if (before) root.insertBefore(a, before); else root.appendChild(a);
    observe(a, el);
  }

  function makeCard(id, title, nodes) {
    if (!nodes.length) return null;
    var el = document.createElement('section');
    el.id = id;
    el.className = 'cv-pdp-card';
    var h = document.createElement('h2');
    h.className = 'cv-pdp-card-title';
    h.textContent = title;
    el.appendChild(h);
    var body = document.createElement('div');
    body.className = 'cv-pdp-card-body';
    nodes.forEach(function (n) { body.appendChild(n); });
    el.appendChild(body);
    return el;
  }

  function refreshClamp() {
    var clamp = document.querySelector('[data-cv-clamp]');
    var more = document.querySelector('[data-cv-more]');
    if (!clamp || !more || clamp.classList.contains('is-open')) return;
    if (clamp.scrollHeight <= clamp.clientHeight + 8) {
      more.style.display = 'none';
      clamp.classList.add('is-open');
    } else {
      more.style.display = '';
    }
  }

  function splitDescription() {
    var desc = document.querySelector('[data-cv-clamp] .prose');
    var descCard = document.querySelector('[data-product-description]');
    if (!desc || !descCard) return false;

    var specs = makeCard('cvsec-specs', 'Specifications', [].slice.call(desc.querySelectorAll('.cv-specs-acc')));
    var docs = makeCard('cvsec-docs', 'Documents', [].slice.call(desc.querySelectorAll('.cv-doclinks')));
    if (!specs && !docs) return false;

    var after = document.getElementById('cvsec-included') || descCard;
    [specs, docs].forEach(function (c) {
      if (!c) return;
      after.parentNode.insertBefore(c, after.nextSibling);
      after = c;
    });

    [].slice.call(desc.children).forEach(function (n) {
      if (!n.textContent.trim() && !n.querySelector('img, table, a')) n.remove();
    });

    addChip('cvsec-specs', 'Specifications', 'a[href$="__purchase_support"], a[href$="__reviews"], a[href$="__install_videos"]');
    addChip('cvsec-docs', 'Documents', 'a[href$="__purchase_support"], a[href$="__reviews"], a[href$="__install_videos"]');
    refreshClamp();
    return true;
  }

  function watchDescription() {
    var desc = document.querySelector('[data-cv-clamp] .prose');
    if (!desc || splitDescription()) return;
    var mo = new MutationObserver(function () {
      if (splitDescription()) mo.disconnect();
    });
    mo.observe(desc, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }

  /* Judge.me's preview badge renders as stars + "7 reviews" under the
     title. Rebuild it as "4.57 [stars] (7)" and put it in the SKU row in
     place of the stock pill. Judge.me reveals the badge after its own
     init, so this polls briefly rather than running once. */
  function moveRatingToMeta() {
    var badge = document.querySelector('.jdgm-prev-badge');
    var stock = document.querySelector('.cv-stock-badge');
    /* 2026-09-04: the SKU row now renders its own rating in Liquid
       (data-cv-rating-jump), so there is nothing to move — just hide
       Judge.me's duplicate preview badge once it appears. */
    if (document.querySelector('[data-cv-rating-jump]')) {
      if (!badge) return false;
      var dup = badge.closest('.jdgm-preview-badge') || badge.parentElement;
      if (dup) dup.classList.add('cv-rating-moved');
      return true;
    }
    if (!badge || !stock) return false;
    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
    var avg = parseFloat(badge.getAttribute('data-average-rating'));
    if (!stars || !count || isNaN(avg)) return false;

    var wrap = document.createElement('a');
    wrap.className = 'cv-rating-inline';
    wrap.href = '#';
    wrap.setAttribute('aria-label', avg.toFixed(2) + ' out of 5 from ' + count + ' reviews');

    var num = document.createElement('span');
    num.className = 'cv-rating-num';
    num.textContent = avg.toFixed(2);

    var copy = stars.cloneNode(true);
    copy.removeAttribute('role');
    copy.removeAttribute('tabindex');
    copy.removeAttribute('aria-label');

    var cnt = document.createElement('span');
    cnt.className = 'cv-rating-count';
    cnt.textContent = '(' + count + ')';

    wrap.appendChild(num);
    wrap.appendChild(copy);
    wrap.appendChild(cnt);
    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToEl(document.querySelector('[id$="__reviews"]'));
    });

    stock.parentNode.replaceChild(wrap, stock);
    /* Judge.me re-shows its badge after its own init, so hide the original
       row with a class the stylesheet can outrank an inline style with. */
    var block = badge.closest('.jdgm-preview-badge') || badge.parentElement;
    if (block) block.classList.add('cv-rating-moved');
    return true;
  }

  function watchRating() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cv-rating-jump]');
      if (!link) return;
      e.preventDefault();
      scrollToEl(document.querySelector('[id$="__reviews"]'));
    });
    if (moveRatingToMeta()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (moveRatingToMeta() || ++tries > 40) clearInterval(timer);
    }, 300);
  }

  /* Coverage selector (radio list, restored 2026-09-04).
     Without a labor map: the Liquid radios (2-Year / 5-Year, "for $X") are
     left exactly as rendered; theme.js owns them, including its
     click-again-to-deselect behavior.
     With [data-labor-variant-map] present (labor product set AND live):
     the two Liquid radios are hidden and a visible radio list of three
     choices is rendered in the same style - 2-Year, 5-Year, 5-Year + Labor
     (the 2-Year + Labor combo was removed 2026-08-31). The visible radios
     use their own name so theme.js's same-term toggle cannot misfire; they
     set the underlying protection radio programmatically (checked + change
     event) and track labor selection here. Clicking the selected radio
     again deselects it, matching the plain-radio behavior. The labor line
     item is merged into theme.js's own /cart/add.js request by a
     narrowly-guarded fetch wrapper below; on any anomaly the request passes
     through untouched. */
  var TIER_LABELS = ['$0-$249','$250-$499','$500-$999','$1,000-$1,499','$1,500-$2,499','$2,500-$3,499','$3,500-$4,999','$5,000-$6,999','$7,000-$9,999','$10,000-$14,999','$15,000+'];
  var laborState = { on: false, term: '', variantId: 0, tier: '', qtyForm: null };

  function laborTermFromVariant(v) {
    var t = ((v && v.option1 ? v.option1 : '') + ' ' + (v && v.title ? v.title : '')).toLowerCase();
    if (t.indexOf('5-year') !== -1 || t.indexOf('5 year') !== -1) return '5-year';
    if (t.indexOf('2-year') !== -1 || t.indexOf('2 year') !== -1) return '2-year';
    return '';
  }
  function laborTierFromVariant(v) {
    var t = (v && v.option2 ? v.option2 : '') + ' ' + (v && v.title ? v.title : '');
    for (var i = 0; i < TIER_LABELS.length; i++) { if (t.indexOf(TIER_LABELS[i]) !== -1) return TIER_LABELS[i]; }
    return '';
  }
  function readLaborMap(section) {
    var el = section.querySelector('[data-labor-variant-map]');
    if (!el) return null;
    var raw = [];
    try { raw = JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
    var list = raw.map(function (v) {
      return { id: Number(v.id), term: laborTermFromVariant(v), tier: laborTierFromVariant(v), price: Number(v.price) || 0, available: v.available !== false };
    }).filter(function (v) { return isFinite(v.id) && v.id > 0 && v.term && v.tier; });
    return list.length ? { list: list, suffix: el.getAttribute('data-suffix') || '+ Labor' } : null;
  }
  function laborVariantFor(map, term, tierLabel) {
    for (var i = 0; i < map.list.length; i++) {
      var v = map.list[i];
      if (v.term === term && v.tier === tierLabel && v.available) return v;
    }
    return null;
  }
  function fmtUsd(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function installCartMerge() {
    if (window.__cvLaborFetch) return;
    window.__cvLaborFetch = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (laborState.on && laborState.variantId > 0 && url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var payload = JSON.parse(init.body);
          if (payload && Array.isArray(payload.items) && payload.items.length) {
            var alreadyThere = payload.items.some(function (it) { return Number(it.id) === laborState.variantId; });
            var productQty = Number(payload.items[0].quantity) || 1;
            var section = document.querySelector('[data-product-section]');
            if (!alreadyThere) {
              payload.items.push({
                id: laborState.variantId,
                quantity: productQty,
                properties: {
                  'Covers': (section && section.dataset.productTitle) || '',
                  '_covered_variant': String(payload.items[0].id || ''),
                  '_coverage_term': laborState.term + '-labor',
                  '_coverage_tier': laborState.tier
                }
              });
              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            }
          }
        }
      } catch (e) { /* pass through untouched */ }
      return origFetch.call(this, input, init);
    };
  }

  function buildPlanChoices() {
    var wrap = document.querySelector('[data-protection-options]');
    if (!wrap || wrap.dataset.cvPlans) return false;
    var section = wrap.closest('[data-product-section]') || document;
    var radios = [].slice.call(wrap.querySelectorAll('input[type="radio"][data-protection-option]'));
    if (!radios.length) return false;
    var laborMap = readLaborMap(section);
    wrap.dataset.cvPlans = '1';

    /* No labor product: the Liquid radio list is already the design. */
    if (!laborMap) return true;

    installCartMerge();
    var byTerm = {};
    var termLabel = {};
    radios.forEach(function (r) {
      var term = r.getAttribute('data-protection-term');
      byTerm[term] = r;
      var lab = r.closest('label');
      var text = lab ? (lab.textContent || '').replace(/\s+/g, ' ').trim() : '';
      /* "2-year protection for $174.00" -> "2-year protection" */
      termLabel[term] = text.split(' for ')[0] || term.replace('-year', '-Year protection');
      if (lab) lab.style.display = 'none'; else r.style.display = 'none';
    });

    var defs = [
      { term: '2-year', labor: false, label: termLabel['2-year'] },
      { term: '5-year', labor: false, label: termLabel['5-year'] },
      /* 2-Year + Labor removed per request 2026-08-31; labor coverage is
         offered on the 5-year term only. */
      { term: '5-year', labor: true, label: termLabel['5-year'] + ' ' + laborMap.suffix }
    ];
    var rows = [];
    var uid = 'cv-plan-' + Math.random().toString(36).slice(2, 7);
    defs.forEach(function (d, k) {
      var id = uid + '-' + k;
      var lab = document.createElement('label');
      lab.className = 'cv-plan-radio flex cursor-pointer items-center gap-2';
      lab.setAttribute('for', id);
      lab.setAttribute('data-cv-plan', d.term + (d.labor ? '-labor' : ''));
      var input = document.createElement('input');
      input.type = 'radio';
      input.id = id;
      input.name = 'cv_plan_choice';
      input.value = d.term + (d.labor ? '-labor' : '');
      input.className = 'h-5 w-5 shrink-0 cv-plan-radio-input';
      var text = document.createElement('span');
      text.className = 'text-base font-medium text-ink';
      var name = document.createElement('span');
      name.className = 'cv-plan-radio-label';
      name.textContent = d.label;
      var price = document.createElement('span');
      price.className = 'cv-plan-radio-price';
      price.textContent = '\u2014';
      text.appendChild(name);
      text.appendChild(document.createTextNode(' for '));
      text.appendChild(price);
      lab.appendChild(input);
      lab.appendChild(text);
      wrap.appendChild(lab);
      rows.push({ el: lab, input: input, priceEl: price, def: d });
    });

    var selected = null; /* index into rows, or null = no coverage */

    function currentTier(term) {
      var r = byTerm[term];
      return (r && r.dataset.protectionTier) || '';
    }
    function protPrice(term) {
      var r = byTerm[term];
      return Number(r && r.dataset.protectionPrice) || 0;
    }
    function setDisabled(row, off) {
      row.input.disabled = off;
      row.el.classList.toggle('cv-plan-radio--off', off);
    }
    function refreshPrices() {
      rows.forEach(function (row) {
        var tier = currentTier(row.def.term);
        var base = protPrice(row.def.term);
        if (!row.def.labor) {
          row.priceEl.textContent = base ? fmtUsd(base) : 'Unavailable';
          setDisabled(row, !base);
          if (!base && selected !== null && rows[selected] === row) applySelection(null);
          return;
        }
        var lv = tier ? laborVariantFor(laborMap, row.def.term, tier) : null;
        if (base && lv) {
          row.priceEl.textContent = fmtUsd(base + lv.price);
          setDisabled(row, false);
        } else {
          row.priceEl.textContent = 'Unavailable';
          setDisabled(row, true);
          if (selected !== null && rows[selected] === row) applySelection(null);
        }
      });
      if (selected !== null && rows[selected].def.labor) {
        var d = rows[selected].def;
        var lv2 = laborVariantFor(laborMap, d.term, currentTier(d.term));
        laborState.variantId = lv2 ? lv2.id : 0;
        laborState.tier = currentTier(d.term);
      }
    }
    function applySelection(idx) {
      selected = idx;
      var def = idx === null ? null : rows[idx].def;
      Object.keys(byTerm).forEach(function (term) {
        var r = byTerm[term];
        var want = !!(def && def.term === term);
        if (r.checked !== want) {
          r.checked = want;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (def && def.labor) {
        var lv = laborVariantFor(laborMap, def.term, currentTier(def.term));
        laborState.on = true;
        laborState.term = def.term;
        laborState.tier = currentTier(def.term);
        laborState.variantId = lv ? lv.id : 0;
      } else {
        laborState.on = false;
        laborState.variantId = 0;
      }
      rows.forEach(function (row, k) {
        row.input.checked = k === idx;
        row.el.classList.toggle('is-selected', k === idx);
      });
    }
    rows.forEach(function (row, k) {
      /* Native radios cannot be unchecked by clicking; mirror theme.js's
         plain-radio behavior so clicking the selected plan again opts out. */
      row.input.addEventListener('click', function () {
        if (selected === k) {
          applySelection(null);
        }
      });
      row.input.addEventListener('change', function () {
        if (row.input.checked && selected !== k) applySelection(k);
      });
    });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(refreshPrices);
      radios.forEach(function (r) {
        mo.observe(r, { attributes: true, attributeFilter: ['data-protection-tier', 'data-protection-price', 'disabled'] });
      });
    }
    refreshPrices();
    applySelection(null);
    setTimeout(refreshPrices, 800);
    return true;
  }

  function watchPlanChoices() {
    if (buildPlanChoices()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (buildPlanChoices() || ++tries > 20) clearInterval(timer);
    }, 300);
  }

  function init() {
    root = document.querySelector('[data-cv-chipnav]');
    if (!root || root.dataset.cvExtras) return;
    root.dataset.cvExtras = '1';

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          tracked.forEach(function (t) {
            t.chip.classList.toggle('is-active', t.target === entry.target);
          });
        });
      }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    }

    root.querySelectorAll('[data-cv-chip]').forEach(function (chip) {
      var el = document.getElementById(chip.getAttribute('href').slice(1));
      if (el) observe(chip, el);
    });

    [
      { id: 'cvsec-included', label: "What's included" },
      { sel: '[id$="__purchase_support"]', label: 'Complete your system' },
      { sel: '[id$="__reviews"]', label: 'Reviews' },
      { sel: '[id$="__install_videos"]', label: 'Install video' }
    ].forEach(function (item) {
      var el = item.id ? document.getElementById(item.id) : document.querySelector(item.sel);
      if (!el || !el.offsetParent || !el.offsetHeight) return;
      if (!el.id) el.id = 'cvsec-extra-' + tracked.length;
      addChip(el.id, item.label, null);
    });

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('a[href^="#"]');
      if (!chip || !root.contains(chip)) return;
      var el = document.getElementById(chip.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (el.tagName === 'DETAILS') el.open = true;
      scrollToEl(el);
    }, true);

    watchDescription();
    watchRating();
    watchPlanChoices();

    if (root.querySelectorAll('a').length < 2) root.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* Chill PDP gallery: hover prev/next arrows over the main image, and a
   click-to-zoom lightbox. The arrows reuse theme.js's delegated
   [data-gallery-prev]/[data-gallery-next] stepping (those controls simply
   never existed in the markup); the lightbox steps through image media and
   keeps the underlying gallery in sync by clicking the matching thumbnail.
   2026-08-31 */
(function () {
  var SVG_PREV = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';
  var SVG_CLOSE = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

  /* Largest useful rendition of a Shopify CDN image URL. */
  function bigSrc(img) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) {
      src = src.replace(/([?&])width=\d+/, '$1width=1800');
    } else {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=1800';
    }
    return src;
  }

  /* Image-type media in display order: [{ media, img }] */
  function mediaImgs(gallery) {
    var out = [];
    gallery.querySelectorAll('[data-product-media]').forEach(function (m) {
      if (m.querySelector('video, iframe, model-viewer')) return;
      var img = m.querySelector('img');
      if (img) out.push({ media: m, img: img });
    });
    return out;
  }

  /* ---------------- Lightbox ---------------- */
  var lb = null;
  var lbItems = [];
  var lbIndex = 0;
  var lbGallery = null;
  var lbZoomed = false;
  var lbBaseRect = null;

  function resetZoom() {
    lbZoomed = false;
    lbBaseRect = null;
    if (lb) {
      lb.img.classList.remove('is-zoomed');
      lb.img.style.transformOrigin = '';
    }
  }

  function render() {
    if (!lb) return;
    if (lbIndex < 0) lbIndex = 0;
    if (lbIndex > lbItems.length - 1) lbIndex = lbItems.length - 1;
    var item = lbItems[lbIndex];
    if (!item) return;
    resetZoom();
    lb.img.src = bigSrc(item.img);
    lb.img.alt = item.img.alt || '';
    var many = lbItems.length > 1;
    lb.prev.hidden = !many;
    lb.next.hidden = !many;
    lb.count.hidden = !many;
    if (many) {
      lb.prev.disabled = lbIndex <= 0;
      lb.next.disabled = lbIndex >= lbItems.length - 1;
      lb.count.textContent = (lbIndex + 1) + ' / ' + lbItems.length;
      /* Warm the neighbor so stepping feels instant. */
      var neighbor = lbItems[lbIndex + 1] || lbItems[lbIndex - 1];
      if (neighbor) { var pre = new Image(); pre.src = bigSrc(neighbor.img); }
    }
  }

  function syncGallery() {
    if (!lbGallery) return;
    var item = lbItems[lbIndex];
    if (!item) return;
    var thumb = lbGallery.querySelector('[data-product-thumbnail][data-media-id="' + item.media.id + '"]');
    if (thumb && thumb.getAttribute('aria-selected') !== 'true') thumb.click();
  }

  function step(direction) {
    var nextIndex = Math.min(Math.max(lbIndex + direction, 0), lbItems.length - 1);
    if (nextIndex === lbIndex) return;
    lbIndex = nextIndex;
    render();
    syncGallery();
  }

  function closeLightbox() {
    if (!lb || lb.root.hidden) return;
    lb.root.hidden = true;
    resetZoom();
    document.documentElement.classList.remove('cv-lb-open');
  }

  function buildLightbox() {
    if (lb) return lb;
    var root = document.createElement('div');
    root.className = 'cv-lightbox';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product image viewer');
    root.innerHTML =
      '<div class="cv-lightbox__backdrop" data-cv-lb-close></div>' +
      '<figure class="cv-lightbox__stage"><img class="cv-lightbox__img" alt=""></figure>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__close" data-cv-lb-close aria-label="Close image viewer">' + SVG_CLOSE + '</button>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__nav cv-lightbox__nav--prev" aria-label="Previous image">' + SVG_PREV + '</button>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__nav cv-lightbox__nav--next" aria-label="Next image">' + SVG_NEXT + '</button>' +
      '<div class="cv-lightbox__count" aria-hidden="true"></div>';
    document.body.appendChild(root);

    lb = {
      root: root,
      stage: root.querySelector('.cv-lightbox__stage'),
      img: root.querySelector('.cv-lightbox__img'),
      close: root.querySelector('.cv-lightbox__close'),
      prev: root.querySelector('.cv-lightbox__nav--prev'),
      next: root.querySelector('.cv-lightbox__nav--next'),
      count: root.querySelector('.cv-lightbox__count')
    };

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cv-lb-close]')) { closeLightbox(); return; }
      if (e.target.closest('.cv-lightbox__nav--prev')) { step(-1); return; }
      if (e.target.closest('.cv-lightbox__nav--next')) { step(1); return; }
      /* Clicking the letterbox area around the picture closes too. */
      if (e.target === lb.stage) { closeLightbox(); return; }
    });

    /* Click the picture to magnify at that spot; click again to reset.
       Skipped on touch devices, where the swipe/arrows do the work. */
    lb.img.addEventListener('click', function (e) {
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
      if (!lbZoomed) {
        lbBaseRect = lb.img.getBoundingClientRect();
        var ox = ((e.clientX - lbBaseRect.left) / lbBaseRect.width) * 100;
        var oy = ((e.clientY - lbBaseRect.top) / lbBaseRect.height) * 100;
        lb.img.style.transformOrigin = ox + '% ' + oy + '%';
        lb.img.classList.add('is-zoomed');
        lbZoomed = true;
      } else {
        resetZoom();
      }
    });

    /* While zoomed, pan by moving the mouse (magnifier behavior). */
    lb.stage.addEventListener('mousemove', function (e) {
      if (!lbZoomed || !lbBaseRect) return;
      var ox = ((e.clientX - lbBaseRect.left) / lbBaseRect.width) * 100;
      var oy = ((e.clientY - lbBaseRect.top) / lbBaseRect.height) * 100;
      lb.img.style.transformOrigin = Math.min(100, Math.max(0, ox)) + '% ' + Math.min(100, Math.max(0, oy)) + '%';
    });

    /* Swipe to step (mobile). */
    var startX = 0, startY = 0, tracking = false;
    lb.stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    lb.stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lb || lb.root.hidden) return;
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); return; }
    });

    return lb;
  }

  function openLightbox(gallery, index) {
    buildLightbox();
    lbGallery = gallery;
    lbItems = mediaImgs(gallery);
    if (!lbItems.length) return;
    lbIndex = index;
    lb.root.hidden = false;
    document.documentElement.classList.add('cv-lb-open');
    render();
    try { lb.close.focus({ preventScroll: true }); } catch (err) { /* noop */ }
  }

  /* Open on click of the visible product image. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gallery-prev], [data-gallery-next], [data-product-thumbnail], .cv-lightbox')) return;
    var mediaDiv = e.target.closest('[data-product-media]');
    if (!mediaDiv || mediaDiv.hidden) return;
    if (mediaDiv.querySelector('video, iframe, model-viewer')) return;
    var gallery = mediaDiv.closest('[data-product-gallery]');
    if (!gallery) return;
    var items = mediaImgs(gallery);
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].media === mediaDiv) { idx = i; break; }
    }
    if (idx === -1) return;
    e.preventDefault();
    openLightbox(gallery, idx);
  });

  /* ---------------- Hover arrows on the main image ---------------- */
  function makeArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cv-gal-arrow cv-gal-arrow--' + (direction < 0 ? 'prev' : 'next');
    btn.setAttribute(direction < 0 ? 'data-gallery-prev' : 'data-gallery-next', '');
    btn.setAttribute('aria-label', direction < 0 ? 'Previous image' : 'Next image');
    btn.innerHTML = direction < 0 ? SVG_PREV : SVG_NEXT;
    return btn;
  }

  function initGalleryChrome() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.hasAttribute('data-cv-gal-ready')) return;
      var firstMedia = gallery.querySelector('[data-product-media]');
      if (!firstMedia) return;
      gallery.setAttribute('data-cv-gal-ready', '1');

      var view = firstMedia.parentElement;
      view.classList.add('cv-gal-view');
      if (mediaImgs(gallery).length) view.classList.add('cv-gal-zoomable');

      var thumbs = gallery.querySelectorAll('[data-product-thumbnail]');
      if (thumbs.length > 1) {
        var prev = makeArrow(-1);
        var next = makeArrow(1);
        view.appendChild(prev);
        view.appendChild(next);
        /* theme.js refreshes disabled state on every selection; set the
           initial state ourselves since we arrived after its first pass. */
        var active = -1;
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('aria-selected') === 'true') { active = i; break; }
        }
        prev.disabled = active <= 0;
        next.disabled = active === -1 || active >= thumbs.length - 1;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryChrome);
  } else {
    initGalleryChrome();
  }
  document.addEventListener('shopify:section:load', initGalleryChrome);
})();

/* Collection toolbar sort menu (2026-09-03).
   A pill button opens a popover listbox; picking an option sets the hidden
   native <select name="sort_by"> and fires its change event so theme.js's
   existing filter handler re-renders the section. Everything is delegated
   from document because that re-render replaces the whole section DOM. */
(function () {
  function wrapOf(el) { return el && el.closest ? el.closest('[data-cv-sort-wrap]') : null; }

  function setOpen(wrap, open) {
    if (!wrap) return;
    var btn = wrap.querySelector('[data-cv-sort-btn]');
    var menu = wrap.querySelector('.cv-sort-menu');
    wrap.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (menu) menu.hidden = !open;
    if (open && menu) {
      var current = menu.querySelector('[aria-selected="true"]') || menu.querySelector('[data-cv-sort-option]');
      if (current) current.focus();
    }
  }

  function closeAll(except) {
    var open = document.querySelectorAll('[data-cv-sort-wrap].is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) setOpen(open[i], false);
    }
  }

  function choose(wrap, value) {
    var sel = wrap.querySelector('[data-cv-sort]');
    var btn = wrap.querySelector('[data-cv-sort-btn]');
    setOpen(wrap, false);
    if (btn) btn.focus();
    if (!sel || sel.value === value) return;
    sel.value = value;
    var label = wrap.querySelector('[data-cv-sort-current]');
    var opt = sel.options[sel.selectedIndex];
    if (label && opt) label.textContent = opt.text;
    var opts = wrap.querySelectorAll('[data-cv-sort-option]');
    for (var i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-selected', opts[i].getAttribute('data-value') === value ? 'true' : 'false');
    }
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cv-sort-btn]');
    if (btn) {
      var wrap = wrapOf(btn);
      var willOpen = !wrap.classList.contains('is-open');
      closeAll(wrap);
      setOpen(wrap, willOpen);
      return;
    }
    var opt = e.target.closest('[data-cv-sort-option]');
    if (opt) {
      choose(wrapOf(opt), opt.getAttribute('data-value'));
      return;
    }
    if (!wrapOf(e.target)) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    var wrap = wrapOf(e.target);
    if (!wrap) return;
    var opts = Array.prototype.slice.call(wrap.querySelectorAll('[data-cv-sort-option]'));
    var idx = opts.indexOf(document.activeElement);
    if (e.key === 'Escape') {
      setOpen(wrap, false);
      var b = wrap.querySelector('[data-cv-sort-btn]');
      if (b) b.focus();
      e.preventDefault();
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!wrap.classList.contains('is-open')) { setOpen(wrap, true); e.preventDefault(); return; }
      var next = e.key === 'ArrowDown' ? Math.min(idx + 1, opts.length - 1) : Math.max(idx - 1, 0);
      if (opts[next]) opts[next].focus();
      e.preventDefault();
    } else if ((e.key === 'Enter' || e.key === ' ') && idx >= 0) {
      choose(wrap, opts[idx].getAttribute('data-value'));
      e.preventDefault();
    } else if (e.key === 'Tab' && wrap.classList.contains('is-open')) {
      setOpen(wrap, false);
    }
  });

  /* Bucketed facets (snippets/cv-facet-buckets.liquid): copy the visible
     checkbox state onto its hidden member inputs. Capture phase, so it runs
     before theme.js's bubble-phase listener serializes the form. */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-cv-bucket]')) return;
    var wrap = box.closest('[data-cv-bucket-wrap]');
    if (!wrap) return;
    var members = wrap.querySelectorAll('[data-cv-bucket-member]');
    for (var i = 0; i < members.length; i++) members[i].checked = box.checked;
  }, true);
})();
